/* tslint:disable */
/* eslint-disable */
/**
 * Adgang API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface InternalUserResponse
 */
export interface InternalUserResponse {
    /**
     * 
     * @type {string}
     * @memberof InternalUserResponse
     */
    userId?: string | null;
    /**
     * 
     * @type {string}
     * @memberof InternalUserResponse
     */
    internalUserId?: string | null;
    /**
     * 
     * @type {string}
     * @memberof InternalUserResponse
     */
    employeeId?: string | null;
    /**
     * 
     * @type {string}
     * @memberof InternalUserResponse
     */
    employmentCategory?: string | null;
    /**
     * 
     * @type {string}
     * @memberof InternalUserResponse
     */
    initials?: string | null;
    /**
     * 
     * @type {string}
     * @memberof InternalUserResponse
     */
    name?: string | null;
    /**
     * 
     * @type {string}
     * @memberof InternalUserResponse
     */
    sectionCode?: string | null;
    /**
     * 
     * @type {string}
     * @memberof InternalUserResponse
     */
    workLocation?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof InternalUserResponse
     */
    isActive?: boolean;
    /**
     * 
     * @type {string}
     * @memberof InternalUserResponse
     */
    firstName?: string | null;
    /**
     * 
     * @type {string}
     * @memberof InternalUserResponse
     */
    lastName?: string | null;
}

/**
 * Check if a given object implements the InternalUserResponse interface.
 */
export function instanceOfInternalUserResponse(value: object): value is InternalUserResponse {
    return true;
}

export function InternalUserResponseFromJSON(json: any): InternalUserResponse {
    return InternalUserResponseFromJSONTyped(json, false);
}

export function InternalUserResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): InternalUserResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'userId': json['userId'] === undefined ? undefined : json['userId'] === null ? null : json['userId'],
        'internalUserId': json['internalUserId'] === undefined ? undefined : json['internalUserId'] === null ? null : json['internalUserId'],
        'employeeId': json['employeeId'] === undefined ? undefined : json['employeeId'] === null ? null : json['employeeId'],
        'employmentCategory': json['employmentCategory'] === undefined ? undefined : json['employmentCategory'] === null ? null : json['employmentCategory'],
        'initials': json['initials'] === undefined ? undefined : json['initials'] === null ? null : json['initials'],
        'name': json['name'] === undefined ? undefined : json['name'] === null ? null : json['name'],
        'sectionCode': json['sectionCode'] === undefined ? undefined : json['sectionCode'] === null ? null : json['sectionCode'],
        'workLocation': json['workLocation'] === undefined ? undefined : json['workLocation'] === null ? null : json['workLocation'],
        'isActive': json['isActive'] == null ? undefined : json['isActive'],
        'firstName': json['firstName'] === undefined ? undefined : json['firstName'] === null ? null : json['firstName'],
        'lastName': json['lastName'] === undefined ? undefined : json['lastName'] === null ? null : json['lastName'],
    };
}

export function InternalUserResponseToJSON(json: any): InternalUserResponse {
    return InternalUserResponseToJSONTyped(json, false);
}

export function InternalUserResponseToJSONTyped(value?: InternalUserResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'userId': value['userId'],
        'internalUserId': value['internalUserId'],
        'employeeId': value['employeeId'],
        'employmentCategory': value['employmentCategory'],
        'initials': value['initials'],
        'name': value['name'],
        'sectionCode': value['sectionCode'],
        'workLocation': value['workLocation'],
        'isActive': value['isActive'],
        'firstName': value['firstName'],
        'lastName': value['lastName'],
    };
}

